import { DialogBody, DialogContent, DialogHeader, DialogTitle } from './ui/dialog.tsx'
import { cn } from '../lib/cn.ts'
import { cleanHTML } from '../lib/html.ts'
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel.tsx'
import { useContext } from 'react'
import { MainContext } from '../context/main.tsx'

interface Translation {
  name: string
  description: string | null
  image_urls: string[]
}

export function DialogTranslationContent ({ translation }: { translation: Translation }): JSX.Element {
  const hasImages = (translation.image_urls?.length ?? 0) > 0
  const hasMultipleImages = (translation.image_urls?.length ?? 0) > 1
  const { mainRef } = useContext(MainContext)

  return (
    <DialogContent className='@container' container={mainRef}>
      <DialogHeader>
        <DialogTitle className='mr-20'>{translation.name}</DialogTitle>
      </DialogHeader>
      <DialogBody
        className={cn('grid gap-8 no-scrollbar overflow-y-auto max-h-[calc(100vh-8rem)]', { '@desktop:grid-cols-2': hasImages })}
      >
        <div
          className='@desktop:text-base'
          dangerouslySetInnerHTML={{ __html: cleanHTML(translation.description ?? '') }}
        />
        {hasImages && (
          <div>
            <Carousel opts={{ align: 'center' }}>
              <CarouselContent>
                {translation.image_urls.map((url) => (
                  <CarouselItem key={url}>
                    <img src={url} alt='' className='object-cover' />
                  </CarouselItem>
                ))}

              </CarouselContent>
              {hasMultipleImages && (
                <>
                  <CarouselPrevious className='cursor-pointer' />
                  <CarouselNext className='cursor-pointer' />
                </>
              )}
            </Carousel>
          </div>
        )}
      </DialogBody>
    </DialogContent>
  )
}
